<template>
  <div
    class="filter-item collapse"
    id="filter-item"
    :class="{ show: searchOpened }"
  >
    <div
      class="curtain"
      @click.self="
        () => {
          $emit('unfocused')
        }
      "
    ></div>
    <div
      v-if="searchOpened"
      tabindex="0"
      style="
        width: 100%;
        left: 0;
        position: absolute;
      "
      @keydown.esc="
        () => {
          $emit('unfocused')
        }
      "
    >
      <div
        style="display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;"
      >
        <div class="col-lg-12" style="padding: 0;">
          <form class="search-input" autocomplete="off" @submit.prevent="">
            <input
              type="text"
              id="filterInput"
              class="form-control container"
              :placeholder="$t('header.market.search')"
              title="Type in a name"
              ref="searchInput"
              :value="searchString"
              @input="searchString = $event.target.value"
            />

            <div
              id="SuggestionFilter"
              :class="{ suggestionsOpened: searchOpened }"
            >
              <ul class="container">
                <li v-for="item in filtered" :key="item.id">
                  <a
                    :href="`/dashboard/${item.ticker}/${item.market.name}`"
                    @click.prevent="changeTicker(item)"
                  >
                    <span class="grey">
                      <img
                        :src="
                          require(`@/assets/flags/${
                            item.market ? item.market.imgName : 'ru.svg'
                          }`)
                        "
                        class="flag ad fnone"
                      />
                      {{ item.market && item.market.name }} </span
                    ><span>{{ item.ticker }}</span> {{ item.company }}
                  </a>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchString: '',
      itemsSource: [],
    }
  },
  computed: {
    filtered() {
      const search = this.searchString.toLowerCase()
      // return this.items.filter(
      //   (el) =>
      //     el.company.indexOf(search) > -1 ||
      //     el.description.indexOf(search) > -1 ||
      //     el.ticker.indexOf(search) > -1
      // )
      return this.items
        .filter((el) => el.title.toLowerCase().indexOf(search) > -1)
        .slice(0, 5)
    },
    items() {
      return this.itemsSource.map((itm) => {
        const CN = itm[`companyName_${this.$i18n.locale}`] || itm.companyName
        const TT = itm.tickerType
        return {
          id: itm.id,
          ticker: itm.ticker,
          market: itm.market,
          company: CN,
          tickerType: TT,
          title: `${itm.ticker} ${CN} ${this.$t('tickerTypes.' + TT)}`, // ${market}
        }
      })
    },
  },
  watch: {
    searchOpened(val) {
      if (val) {
        // DO NOT update ?  && Array.from(this.itemsSource).length == 0
        this.$store.dispatch('request/getScreenerBO').then((data) => {
          this.itemsSource = data.map((el) => ({
            // ...el,
            id: el.name,
            ticker: el.name.split(':')[1] || el.name,
            market: el.market,
            tickerType: el.tickerType || 'comm_stock',
            ...(el.ticker_id && {
              companyName_ru:
                el.ticker_id.companyName_ru || el.ticker_id.companyName,
              companyName_en:
                el.ticker_id.companyName_en || el.ticker_id.companyName,
            }),
          }))
        })
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    },
  },
  methods: {
    changeTicker(item) {
      this.$router.push(`/dashboard/${item.ticker}/${item.market.name}`)
      this.$emit('unfocused')
    },
    initSearch(val) {
      this.searchString = val
    },
  },
}
</script>

<style lang="scss">
.btn-filter-item {
  background-color: transparent;
  font-style: normal;
  font-weight: bold;
  font-size: 2rem;
  line-height: 1.25rem;
}
.filter-item {
  width: 100%;
  position: absolute;
  background-color: #fff;
  border-bottom: 1px solid $primary-color2;
  z-index: 9999;
  height: 64px;
  top: 0;
  left: 0;

  &.collapse.show {
    display: block !important;
  }

  // &:before,
  & .curtain {
    width: 100%;
    height: 100%;
    background-color: rgba(#fff, 0.8);
    content: '';
    position: fixed;
  }

  .form-control {
    height: auto;
    padding: 0 15px;
    font-size: 1.23rem;
    line-height: 3.07rem;
    border: none;

    @include placeholder {
      color: #c2c2d6;
    }

    @media (min-width: 575.99px) {
      margin-top: 5px;
      margin-bottom: 5px;
      border: 0;
      font-size: 2rem;
      line-height: 2.5rem;
      padding: 0.375rem 15px;
    }
  }
}
</style>
